import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../AuthContext";

export default function Landing() {
  const { user } = useAuth();
  const goTo = user
    ? { admin: "/english-id/admin", family: "/english-id/family" }[user.role] || "/english-id/student"
    : "/english-id/login";

  return (
    <div className="pt-6">
      <div className="grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <span className="inline-block text-[11px] font-semibold tracking-widest text-[#4F6B47] px-3 py-1 border border-[#4F6B47]/40 rounded-full">
            NUEVO · ENGLISH ID
          </span>
          <h1 className="mt-6 font-serif text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.02]">
            Carnet digital, progreso real.
          </h1>
          <p className="mt-6 text-[15px] leading-relaxed text-[#132C44]/75 max-w-md">
            Un carnet con QR para cada alumno/a de Pinar English, acceso privado a su progreso por habilidad, asistencia, objetivos y devoluciones docentes.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to={goTo}
              className="px-5 py-3 rounded-full bg-[#132C44] text-[#F6EFDF] text-[13px] font-semibold hover:bg-[#1E3A5F] transition"
              data-testid="eid-cta-start"
            >
              {user ? "Ir a mi panel" : "Ingresar a mi English ID"}
            </Link>
            <Link
              to="/"
              className="px-5 py-3 rounded-full border border-[#132C44]/30 text-[13px] font-semibold hover:bg-[#132C44] hover:text-[#F6EFDF] transition"
              data-testid="eid-back-landing"
            >
              Volver al sitio
            </Link>
          </div>
          <ul className="mt-10 space-y-2 text-[13px] text-[#132C44]/75">
            <li>· Carnet con QR verificable públicamente (sin datos sensibles)</li>
            <li>· Rúbrica por habilidad: listening, speaking, reading, writing</li>
            <li>· Asistencia, objetivos y comentarios docentes</li>
            <li>· Acceso privado por alumno/a</li>
          </ul>
        </div>

        <div className="relative">
          <div className="aspect-[3/4] max-w-sm mx-auto rounded-3xl bg-[#132C44] text-[#F6EFDF] p-7 shadow-2xl shadow-[#132C44]/30 rotate-[-2deg]">
            <div className="flex items-center justify-between">
              <span className="text-[10px] tracking-widest font-semibold opacity-80">
                PINAR ENGLISH · ID 2026
              </span>
              <span className="h-8 w-8 rounded-md bg-[#8AA986] text-[#132C44] font-bold flex items-center justify-center text-[11px]">
                PE
              </span>
            </div>
            <div className="mt-10">
              <div className="h-24 w-24 rounded-full bg-[#F6EFDF]/10 border border-[#F6EFDF]/20" />
              <h3 className="mt-5 font-serif text-2xl">Alumno/a</h3>
              <p className="text-[11px] uppercase tracking-widest opacity-70 mt-1">
                PE-2026-XXXX
              </p>
            </div>
            <div className="mt-8 flex justify-end">
              <div className="h-20 w-20 bg-[#F6EFDF] rounded-md grid place-items-center">
                <div className="grid grid-cols-6 gap-[2px] p-2">
                  {Array.from({ length: 36 }).map((_, i) => (
                    <span
                      key={i}
                      className="w-[6px] h-[6px]"
                      style={{
                        background: Math.random() > 0.5 ? "#132C44" : "transparent",
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
